/* unplugin-vue-components disabled */import { render } from "./FormCheckboxGroup.vue?vue&type=template&id=214087a0&ts=true"
import script from "./FormCheckboxGroup.vue?vue&type=script&lang=ts"
export * from "./FormCheckboxGroup.vue?vue&type=script&lang=ts"

import "./FormCheckboxGroup.vue?vue&type=style&index=0&id=214087a0&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__